import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudCardModule,
	FreudTagModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';

import { MoodTrackerReportCardComponent } from './moodtracker-report-card.component';

@NgModule({
	imports: [
		CommonModule,
		FreudCardModule,
		FreudTagModule,
		FreudTypographyModule,
		FreudTagModule,
	],
	declarations: [MoodTrackerReportCardComponent],
	exports: [MoodTrackerReportCardComponent],
})
export class MoodTrackerReportCardModule {}
